<script setup>
import AdvancedConversationManager from '@/views/apps/conversation/list/AdvancedConversationManager.vue'
import BotsController from '@/Controller/bots'
import { ReportsController } from '@/Controller/reports'
import StaticReport from '@/components/reports/StaticReport.vue'
import BotQuestionsChart from '@/views/apps/bot/dashboards/BotQuestionsChart.vue'
import BotQuestionPerConversationChart from '@/views/apps/bot/dashboards/BotQuestionPerConversationChart.vue'
import { formatDateLocalYM } from '@/utils/utils'

definePage({
  meta: {
    action: 'read',
    subject: 'bots',
    useBotNav: true,
  },
})

import { useRoute } from 'vue-router'

// Get the bot ID from the route params
const route = useRoute()
const botId = Number.parseInt(route.params.id)
const bot = await BotsController.getBot(botId)
const botReport = await ReportsController.getBotReport(botId)
const botMessagesTimelineReports = await ReportsController.GetBotMessagesTimelineReports(botId)
</script>

<template>
  <!-- Old version of add new feedback -->
  <!--
    <FeedBack
    :bot-id="botId"
    :disable-user-question="false"
    :can-minimize="false"
    /> 
  -->

  <div class="d-flex justify-space-between flex-wrap gap-4 flex-column flex-md-row mt-4">
    <div v-for="{ title, value, icon, color } in [
      { title: 'Conversations count', value: botReport.participantCount, icon: 'tabler-messages', color: 'primary' },
      { title: 'Questions count', value: botReport.questionCount, icon: 'tabler-message-question', color: 'info' },
      { title: 'Database Connections', value: botReport.bot.dbConnectionData ? '1' : '0', icon: 'tabler-database-cog', color: 'warning' },
      { title: 'Tables', value: botReport.tablesCount, icon: 'tabler-table', color: 'success' },
    ]" :key="title">

      <StaticReport :icon="icon" :color="color" :title="title" :value="value" />



    </div>
    <VDivider />
    <BotQuestionsChart :users="botMessagesTimelineReports.map(bmt => bmt.users)"
      :questions="botMessagesTimelineReports.map(bmt => bmt.questions)"
      :time-line="botMessagesTimelineReports.map(bmt => formatDateLocalYM(bmt.dateTime, false))" />
    <BotQuestionPerConversationChart :labels="[$t('Conversations count'),$t('Questions count')]" :series="[botReport.participantCount,botReport.questionCount]" />
  </div>
</template>
